









import { computed, defineComponent } from '@vue/composition-api';
import { PanelProps } from '../../types/panel';
import { useWorkFlow } from '../../composables';

export default defineComponent<PanelProps>({
  name: 'WorkflowPanel',

  props: {
    position: { type: String, required: true }
  },

  setup(props) {
    const { userSelectionActive } = useWorkFlow();

    const positionClasses = computed(() => `${props.position}`.split('-'));

    return {
      positionClasses,
      userSelectionActive
    };
  }
});
